document.addEventListener('DOMContentLoaded', () => {
  const judgemeReviewWidgetList = document.querySelectorAll('.jdgm-rev__prod-link');
  if (!judgemeReviewWidgetList.length) return;

  for (const elem of judgemeReviewWidgetList) {
    elem.removeAttribute('href');
  }
});

